import { DataProductPage } from './DataProductPage';

export * from './catalogData';
export * from './components';
export * from './ComponentSubPage';
export * from './DataProductCustomView';
export * from './DataProductSubPage';
export * from './EntityCustomView';
export const CustomViews = { DataProductPage };
